import "./Dropdown.scss";
import { FunctionComponent } from "react";
import AsyncSelect from 'react-select/async';

interface IProps {
  label?: string;
  placeholder: string;
  value?: any;
  defaultOptions?: any;
  defaultValue?: any;
  onChange: any;
  className?: string;
  isMulti?: boolean;
  innerRef?: any;
  onFocus?: any;
  onInputChange?: any
  loadOptions: any;
  onMenuScrollToBottom?: any;
  isLoading: boolean;
}

const AsyncDropdown: FunctionComponent<IProps> = (props) => {
  const {
    defaultOptions,
    label,
    onChange,
    placeholder,
    isMulti,
    className,
    value,
    innerRef,
    onFocus,
    onInputChange,
    loadOptions,
    onMenuScrollToBottom,
    isLoading
  } = props;
  return (
    <div className="dropdown-container">
      {label && <label>{label}</label>}
      <AsyncSelect
        ref={innerRef}
        className={"basic-single " + className}
        classNamePrefix="select"
        placeholder={placeholder}
        isMulti={isMulti}
        isLoading={isLoading}
        isSearchable={true}
        isClearable={false}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onInputChange={onInputChange}
        loadOptions={loadOptions}
        closeMenuOnSelect={false}
        defaultOptions={defaultOptions}
        cacheOptions
        onMenuScrollToBottom={onMenuScrollToBottom}
      />
    </div>
  );
};

export default AsyncDropdown;
